import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import GenerateCampaign from "../../../assets/AdsGeneration/icons/api-generate-campaign.svg";
import GetBrands from "../../../assets/AdsGeneration/icons/api-get-brands.svg";
import GetTemplateById from "../../../assets/AdsGeneration/icons/api-get-template.svg";
import GetTemplates from "../../../assets/AdsGeneration/icons/api-get-templates.svg";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";

const AdsGenerationAPI = () => {
	const { t } = useTranslation("translation", { keyPrefix: "adsGeneration.api" });
	const openDocs = (link: string) => window.open(link, "_blank");

	const adsGenerationApiCards: ConsoleAPICardProps[] = [
		{
			image: GetBrands,
			imageType: "icon",
			header: t("cards.getBrands.header"),
			description: t("cards.getBrands.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.ADS_GENERATION.GET_BRANDS.DOCS)}
				>
					{t("cards.getBrands.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.ADS_GENERATION.GET_BRANDS.DOCS),
		},
		{
			image: GetTemplates,
			imageType: "icon",
			header: t("cards.getTemplates.header"),
			description: t("cards.getTemplates.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.ADS_GENERATION.GET_TEMPLATES.DOCS)}
				>
					{t("cards.getTemplates.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.ADS_GENERATION.GET_TEMPLATES.DOCS),
		},
		{
			image: GetTemplateById,
			imageType: "icon",
			header: t("cards.getTemplateById.header"),
			description: t("cards.getTemplateById.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.ADS_GENERATION.GET_TEMPLATE.DOCS)}
				>
					{t("cards.getTemplateById.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.ADS_GENERATION.GET_TEMPLATE.DOCS),
		},
		{
			image: GenerateCampaign,
			imageType: "icon",
			header: t("cards.generateCampaign.header"),
			description: t("cards.generateCampaign.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.ADS_GENERATION.GENERATE_CAMPAIGN.DOCS)}
				>
					{t("cards.generateCampaign.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.ADS_GENERATION.GENERATE_CAMPAIGN.DOCS),
		},
	];

	return (
		<ConsoleAPILayout description={t("description")}>
			<ConsoleAPICards cards={adsGenerationApiCards} />
		</ConsoleAPILayout>
	);
};

export default observer(AdsGenerationAPI);
